window.addEventListener('load', () => {
  const formSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
  const formFailure = window.location.search.indexOf('accepts_marketing') !== -1;

  if (formSuccess || formFailure) {
    setTimeout(() => {
      const footerOffset = document.querySelector('.site-footer').getBoundingClientRect().top + window.scrollY;
      const announcementBarHeight = document.querySelector('.announcement').offsetHeight;

      window.scrollTo({
        top: footerOffset - announcementBarHeight,
        left: 0,
        behavior: 'smooth',
      });
    }, 150);
  }

  if (window.location.pathname === '/challenge') {
    const challengeContainer = document.querySelector('.shopify-challenge__container');
    if (challengeContainer) challengeContainer.style.display = 'block';
    
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }, 300);
  }
});

const stickyAddCartButton = document.querySelector('.sticky-add-cart__btn');
stickyAddCartButton?.addEventListener('click', () => {
  const productFormAddCartButton = document.querySelector('.product-section [data-add-to-cart]');
  productFormAddCartButton?.click();
});

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest('.shopify-section');
    this.variantPicker = this.section.querySelector('.product-block--variant-picker');
    this.form = this.section.querySelector('.product-single__form');
    this.paymentButtons = this.section.querySelector('.shopify-payment-button');

    this.sellingPlanGroups = this.querySelectorAll('.selling-plan__group-input');
    this.sellingPlans = this.querySelectorAll('.selling-plan__input'); 

    this.init();
  }

  init() {
    this.form?.insertAdjacentHTML('beforeend', `<input type="hidden" name="selling_plan" value="">`);
    this.paymentButtons?.classList.add('hide');

    this.updateSellingPlan();
    this.addLogicToSubscriptionWidgetForShopifyPayments();

    this.sellingPlanGroups.forEach(sellingPlanGroup => {
      sellingPlanGroup.addEventListener('change', () => {
        this.updateSellingPlan();
      });
    });

    this.querySelectorAll('.subscription-widget__select').forEach(select => {
      const selectValue = select.querySelector('.subscription-widget__select-value');
      const selectOptions = select.querySelectorAll('.selling-plan__input');

      select.addEventListener('click', () => {
        select.classList.toggle('is-open');
      });

      selectOptions.forEach(option => {
        option.addEventListener('click', (event) => {
          event.stopPropagation();

          this.updateSellingPlan();
          this.updatePrice();
          
          select.classList.remove('is-open');
          if (selectValue) selectValue.textContent = option.dataset.name;
        });
      });
    });

    this.variantPicker?.addEventListener('change', () => {
      this.updateSellingPlan();
      this.updatePrice();
    });
  }

  addLogicToSubscriptionWidgetForShopifyPayments() {
    try {
      let shopifyPaymentTerms = document.querySelector('.shopify-payment-terms.product__policies');
      if (!shopifyPaymentTerms) return;
      shopifyPaymentTerms.style.display = 'none';

      this.querySelectorAll('.subscription-widget__group').forEach(sellingPlanGroup => {
        sellingPlanGroup.addEventListener('change', () => {
          try {
            shopifyPaymentTerms.style.display = sellingPlanGroup.dataset.group === 'once' ? 'block' : 'none';
          } catch (err) {
            console.error(err);
          }
        });
      });
    } catch (err) {
      console.error(err);
    }
  }


  getVariantsData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }

  getCurrentVariant() {
    const variants = this.getVariantsData();
    const options = Array.from(this.variantPicker.querySelectorAll('input:checked'), input => input.value);

    return variants.find(variant => variant.options.every(option => options.includes(option)));
  }

  getSellingPlanAllocation() {
    const currentSellingPlanGroup = Array.from(this.sellingPlanGroups).find(input => input.checked);
    const currentSellingPlan = Array.from(this.sellingPlans).find(input => input.dataset.sellingPlanGroupId == currentSellingPlanGroup.value && input.checked);

    if (!currentSellingPlan) return null;

    const sellingPlanAllocations = this.getCurrentVariant().selling_plan_allocations;
    return sellingPlanAllocations.find(sellingPlanAllocation => sellingPlanAllocation.selling_plan_id == currentSellingPlan.value);
  }

  updateSellingPlan() {
    const sellingPlanInput = this.section.querySelector('input[name="selling_plan"]');
    const currentSellingPlanAllocation = this.getSellingPlanAllocation();

    sellingPlanInput.value = (currentSellingPlanAllocation) ? currentSellingPlanAllocation.selling_plan_id : '';

    if (currentSellingPlanAllocation) {
      this.paymentButtons?.classList.add('hide');
    } else {
      this.paymentButtons?.classList.remove('hide');
    }
  }

  updatePrice() { 
    const currentVariant = this.getCurrentVariant();

    this.querySelectorAll('.subscription-widget__group').forEach(sellingPlanGroup => {
      if (sellingPlanGroup.dataset.group == 'subscription') {
        const currentSellingPlanId = Array.from(sellingPlanGroup.querySelectorAll('.selling-plan__input')).find(input => input.checked).value;
        const currentSellingPlanAllocation = currentVariant.selling_plan_allocations.find(sellingPlanAllocation => sellingPlanAllocation.selling_plan_id == currentSellingPlanId);

        const price = sellingPlanGroup.querySelector('.subscription-widget__group-price');
        if (price) price.innerHTML = `<span class="price-original">${theme.Currency.formatMoney(currentSellingPlanAllocation.compare_at_price, theme.settings.moneyFormat).replace(/\.00$/, '')}</span><span class="price-sale">${theme.Currency.formatMoney(currentSellingPlanAllocation.price, theme.settings.moneyFormat).replace(/\.00$/, '')}</span>`;

        const discount = sellingPlanGroup.querySelector('.subscription-widget__group-discount');
        const discountPercentage = ((currentSellingPlanAllocation.compare_at_price - currentSellingPlanAllocation.price) / currentSellingPlanAllocation.compare_at_price) * 100;

        if (discount) discount.textContent = `${discountPercentage.toFixed(0)}%`;
      } else {
        const price = sellingPlanGroup.querySelector('.subscription-widget__group-price');
        if (price) price.innerHTML = `<span class="price-sale">${theme.Currency.formatMoney(currentVariant.price, theme.settings.moneyFormat).replace(/\.00$/, '')}</span>`;
      }
    });
  }
}

customElements.define('subscription-widget', SubscriptionWidget);

class CartSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.sellingPlanGroups = this.querySelectorAll('.selling-plan__group-input');
    this.sellingPlans = this.querySelectorAll('.selling-plan__input'); 

    this.item = this.closest('.cart__item');
    this.variant = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.init();
  }

  init() {
    this.sellingPlanGroups.forEach(sellingPlanGroup => {
      sellingPlanGroup.addEventListener('change', () => {
        this.sellingPlanChanged();

        const subscriptionIcon = sellingPlanGroup.closest('.cart__item').querySelector('.cart__item--subscribed');
        if (!subscriptionIcon) return;
        
        if (sellingPlanGroup.value == 'once') {
          subscriptionIcon.classList.remove('is-subscribed');
        } else {
          subscriptionIcon.classList.add('is-subscribed')
        }
      });
    });

    this.querySelectorAll('.subscription-widget__select').forEach(select => {
      const selectValue = select.querySelector('.subscription-widget__select-value');
      const selectOptions = select.querySelectorAll('.selling-plan__input');

      select.addEventListener('click', () => {
        select.classList.toggle('is-open');
      });

      selectOptions.forEach(option => {
        option.addEventListener('click', (event) => {
          event.stopPropagation();

          this.updatePrice(option);

          const sellingPlanGroup = option.closest('.subscription-widget__group'), sellingPlanGroupInput = sellingPlanGroup.querySelector('.selling-plan__group-input');
          if (sellingPlanGroupInput && sellingPlanGroupInput.checked) this.sellingPlanChanged();
          
          select.classList.remove('is-open');
          if (selectValue) selectValue.textContent = option.dataset.name;
        });
      });
    });
  }

  getSellingPlanId() {
    const currentSellingPlanGroup = Array.from(this.sellingPlanGroups).find(input => input.checked);
    const currentSellingPlan = Array.from(this.sellingPlans).find(input => input.dataset.sellingPlanGroupId == currentSellingPlanGroup.value && input.checked);

    if (!currentSellingPlan) return null;

    const sellingPlanAllocations = this.variant.selling_plan_allocations;
    return sellingPlanAllocations.find(sellingPlanAllocation => sellingPlanAllocation.selling_plan_id == currentSellingPlan.value).selling_plan_id;
  }

  sellingPlanChanged() {
    const key = this.item.dataset.key,
          qty = this.item.querySelector('.js-qty__num').value;

    const namespace = this.closest('#CartDrawer') ? '.cart-cart-drawer' : '.cart-page';

    document.dispatchEvent(new CustomEvent('cart:quantity' + namespace, {
      detail: [key, qty, this]
    }));
  }

  updatePrice(option) { 
    const currentSellingPlanAllocation = this.variant.selling_plan_allocations.find(sellingPlanAllocation => sellingPlanAllocation.selling_plan_id == option.value);

    const price = document.getElementById(`CartSellingPlanPrice-${this.item.dataset.key}`);

    if (price) price.innerHTML = `<span class="price-original">${theme.Currency.formatMoney(currentSellingPlanAllocation.compare_at_price, theme.settings.moneyFormat).replace(/\.00$/, '')}</span><span class="price-sale">${theme.Currency.formatMoney(currentSellingPlanAllocation.price, theme.settings.moneyFormat).replace(/\.00$/, '')}</span>`;

    const discount = document.getElementById(`CartSellingPlanDiscount-${this.item.dataset.key}`);
    const discountPercentage = ((currentSellingPlanAllocation.compare_at_price - currentSellingPlanAllocation.price) / currentSellingPlanAllocation.compare_at_price) * 100;

    if (discount) discount.textContent = `${discountPercentage.toFixed(0)}%`;
  }
}

customElements.define('cart-subscription-widget', CartSubscriptionWidget);


class ReturnForm extends HTMLElement {
  constructor() {
    super();

    this.inputs = this.querySelectorAll('.return-form__input');
    this.inputs.forEach(input => {
      input.addEventListener('input', () => {
        this.validate();
      });
    });

    this.submit = this.querySelector('.return-form__button');
  }

  validate() {
    const isValid = Array.from(this.inputs).every(input => input.value);

    if (isValid) {
      this.submit.removeAttribute('disabled');
    } else {
      this.submit.setAttribute('disabled', 'disabled');
    }
  }
}

customElements.define('return-form', ReturnForm);